import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Box } from '@chakra-ui/react';
import { Facebook as FacebookIcon } from '../../../../context/Chakra/Icons';
import { PANEL } from '../../../constants/panel';
import { useAppContext } from '../../../context/appContext';
import {
  EVENT_CATEGORY_FOR_USER_FLOW,
  VALUE_FOR_USER_FLOW,
  PROPERTY_FOR_USER_FLOW,
  EVENT_NAME_FOR_USER_FLOW,
} from '../../../../../shop/constants/signupLoginEventsTracking';
import trackerService from '../../../../../service/trackerService';
import { saveCurrentScrollToMountState } from '../../../../OnePageStoreCheckout/utils/onePageStoreMountState';
import { postRedirect } from '../../../../../utils/redirect';

const FacebookAccount = (props) => {
  const { currentPanel, isSubscribed, e2eId, isButtonStyle } = props;
  const { isOnePageStorePopup } = useAppContext();
  const facebookUrl = useMemo(() => {
    let url = '/users/auth/facebook';
    const params = new URLSearchParams();
    if (currentPanel === PANEL.SIGN_UP) {
      params.set('signup', true);
    }
    if (isSubscribed) {
      params.set('marketing', true);
    }
    const urlQueries = new URLSearchParams(window.location.search);
    const encryptDataParams = urlQueries.get('encrypt_data');
    if (encryptDataParams) {
      // URLSearchParams will decode params once so we need to encode to handle uri contains plus symbol case
      // as fb redirect_uri
      const encryptData = encodeURIComponent(encryptDataParams);
      params.set('encrypt_data', encryptData);
    }
    const from = urlQueries.get('from');
    if (['shop_crm', 'pos'].includes(from)) {
      params.set('from', from);
    }
    const stringifyParams = params.toString();
    if (stringifyParams.length > 0) {
      url = `${url}?${stringifyParams}`;
    }
    return url;
  }, [currentPanel, isSubscribed]);

  const handleClick = () => {
    if (isOnePageStorePopup) {
      saveCurrentScrollToMountState();
    }

    if (currentPanel === PANEL.SIGN_UP) {
      trackerService.track({
        type: EVENT_NAME_FOR_USER_FLOW.ThirdPartySignUpClick,
        data: {
          event_category: EVENT_CATEGORY_FOR_USER_FLOW.SignUp,
          property: PROPERTY_FOR_USER_FLOW.sign_up_option,
          value: VALUE_FOR_USER_FLOW.facebook,
        },
      });
    } else if (currentPanel === PANEL.LOGIN) {
      trackerService.track({
        type: EVENT_NAME_FOR_USER_FLOW.ThirdPartyLoginClick,
        data: {
          event_category: EVENT_CATEGORY_FOR_USER_FLOW.MemberLogin,
          property: PROPERTY_FOR_USER_FLOW.login_option,
          value: VALUE_FOR_USER_FLOW.facebook,
        },
      });
    }

    postRedirect(facebookUrl);
  };

  return isButtonStyle ? (
    <Box
      flex={1}
      border="1px solid #e7e7e7"
      borderRadius="4px"
      padding="12px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      onClick={handleClick}
    >
      <FacebookIcon boxSize="20px" color="#1877F2" mr="8px" />{' '}
      <Box fontSize="12px" fontWeight={600} lineHeight="20px">
        Facebook
      </Box>
    </Box>
  ) : (
    <IconButton aria-label="facebook login" variant="plain">
      <FacebookIcon
        data-e2e-id={e2eId}
        color="#1877F2"
        boxSize="40px"
        onClick={handleClick}
      />
    </IconButton>
  );
};

FacebookAccount.propTypes = {
  currentPanel: PropTypes.oneOf([PANEL.LOGIN, PANEL.SIGN_UP]).isRequired,
  isSubscribed: PropTypes.bool,
  e2eId: PropTypes.string,
  isButtonStyle: PropTypes.bool,
};

export default FacebookAccount;
